// Services pour récupérer les données géographiques depuis une API externe
import axios from 'axios';

// API GeoNames
const GEONAMES_API_BASE = 'http://api.geonames.org';
const GEONAMES_USERNAME = 'milkadev';

/**
 * Récupère la liste de tous les pays via GeoNames
 * @returns {Promise<Array>} Liste des pays {name, code, geonameId}
 */
export const fetchCountries = async () => {
    try {
        const response = await axios.get(`${GEONAMES_API_BASE}/countryInfoJSON?username=${GEONAMES_USERNAME}`);
        if (response.data.geonames) {
            return response.data.geonames
                .map(country => ({
                    name: country.countryName,
                    code: country.countryCode,
                    geonameId: country.geonameId
                }))
                .sort((a, b) => a.name.localeCompare(b.name));
        }
        return [];
    } catch (error) {
        console.error('Erreur lors du chargement des pays:', error);
        throw new Error('Impossible de charger la liste des pays');
    }
};

/**
 * Récupère les régions/départements d'un pays via son Geoname ID
 * @param {number} geonameId - ID Geonames du pays
 * @returns {Promise<Array>} Liste des régions {name, geonameId}
 */
export const fetchRegionsByCountry = async (geonameId) => {
    try {
        if (!geonameId) return [];

        const response = await axios.get(
            `${GEONAMES_API_BASE}/childrenJSON?geonameId=${geonameId}&username=${GEONAMES_USERNAME}`
        );

        if (response.data.geonames) {
            return response.data.geonames
                .map(region => ({
                    name: region.name,
                    geonameId: region.geonameId
                }))
                .sort((a, b) => a.name.localeCompare(b.name));
        }
        return [];
    } catch (error) {
        console.error('Erreur lors du chargement des régions:', error);
        return [];
    }
};

/**
 * Récupère les villes d'une région
 * @param {string} geonameId - ID Geonames de la région
 * @returns {Promise<Array>} Liste des villes {name}
 */
export const fetchCitiesByRegion = async (geonameId) => {
    try {
        const response = await axios.get(
            `${GEONAMES_API_BASE}/childrenJSON?geonameId=${geonameId}&username=${GEONAMES_USERNAME}`
        );

        if (response.data.geonames) {
            return response.data.geonames
                .map(city => ({
                    name: city.name
                }))
                .sort((a, b) => a.name.localeCompare(b.name));
        }
        return [];
    } catch (error) {
        console.error('Erreur lors du chargement des villes:', error);
        throw new Error('Impossible de charger les villes');
    }
};

/**
 * Données de fallback en cas d'échec de l'API
 */
export const FALLBACK_COUNTRIES = [
    { name: 'France', code: 'FR', geonameId: 3017382 },
    { name: 'Sénégal', code: 'SN', geonameId: 2245662 },
    { name: 'Côte d\'Ivoire', code: 'CI', geonameId: 2287781 },
    { name: 'Cameroun', code: 'CM', geonameId: 2233387 },
    { name: 'Burkina Faso', code: 'BF', geonameId: 2361809 },
    { name: 'Mali', code: 'ML', geonameId: 2453866 },
    { name: 'Bénin', code: 'BJ', geonameId: 2395170 },
    { name: 'Togo', code: 'TG', geonameId: 2363686 },
    { name: 'Niger', code: 'NE', geonameId: 2440476 },
    { name: 'Guinée', code: 'GN', geonameId: 2420477 },
].sort((a, b) => a.name.localeCompare(b.name));
